import Page from 'src/guidelines/index';

export default Page;
